import React, { useEffect, useState } from "react";
import { useLanguage } from "../languageContext";
import translations from "../translation.json";
import AppointmentsSection from "./appointmentsSection";
import SingleAppointmentsSection from "./singleAppointmentsSection.";
import FollowUp from "./followup";
import EventViewHeader from "./EventViewHeader";
import { ApiUrl } from "../ApiUrl";
import { toast } from "react-toastify";

const EvenView = ({
  isDarkMode,
  setDisplayComponent,
  setPrevDisplay,
  setIsLoading,
}) => {
  const { language } = useLanguage();
  const [eventId, setEventId] = useState(null);
  const [dashboardData, setDashboardData] = useState("");
  const [fidgiContest, setFidgiContest] = useState(null);
  const [eventDates, setEventDates] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Get the current URL
    var currentUrl = window.location.href;
    // Check if '=' is found and extract the text after it
    const equalsIndex = currentUrl.indexOf("=");
    if (equalsIndex !== -1) {
      const secondEqualsIndex = currentUrl.indexOf("=", equalsIndex + 1);

      if (secondEqualsIndex !== -1) {
        const lastParameterValue = currentUrl.substring(secondEqualsIndex + 1);
        setEventId(lastParameterValue);
      }
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const res = await fetch(ApiUrl + "/api/user/graph-dashboard", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            event_id: eventId,
            // graphDate: new Date(),
            // appointmentDate: new Date(),
            // followUpDate: new Date(),
          }),
        });
        const data = await res.json();
        if (data.status === "success") {
          // const newData = data.private_events.data;
          setDashboardData(data);
          // set local fidgiContest state so we can show an inline alert instead of a toast
          setFidgiContest(data?.fidgi_contest);
        } else {
          toast.error(data.message);
        }
        // setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
        setIsLoading(false);
      }
    };
    const getDates = async () => {
      try {
        // setIsLoading(true);
        const res = await fetch(ApiUrl + `/api/user/fillter-dates/${eventId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (data.status === "success") {
          const newData =
            data.appointment_dates &&
            data.appointment_dates.length > 0 &&
            data.appointment_dates.map((item) => {
              return { label: item, value: item };
            });
          setEventDates(newData);
        } else {
          toast.error(data.message);
        }
      } catch (err) {
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
        // setIsLoading(false);
      }
    };
    if (token && eventId) {
      fetchData();
      getDates();
    }
  }, [eventId]);

  async function getDataByDate(bodyData, sectionType) {
    try {
      setIsLoading(true);
      const res = await fetch(ApiUrl + "/api/user/graph-dashboard", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          event_id: eventId,
          [Object.keys(bodyData)[0]]: bodyData[Object.keys(bodyData)[0]],
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        // console.log(data[sectionType]);

        // const newData = data;
        setDashboardData((prev) => ({
          ...prev,
          [sectionType]: data[sectionType],
          graphDate: data?.graphDate,
        }));
      } else {
        toast.error(data.message);
      }
      // setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <div className="container maincont">
        <div id="app" className="appcountainer2">
          <div className="px-1">
            {fidgiContest && fidgiContest?.toLowerCase() === "yes" && (
              <div
                className="alert alert-success mx-2 d-flex align-items-center fidgi-alert"
                role="alert"
              >
                <i className="bi bi-exclamation-triangle-fill fidgi-main-icon" aria-hidden="true"></i>
                {/* <i className="bi bi-trophy-fill fidgi-icon" aria-hidden="true"></i> */}
                <span className="fidgi-text">{translations.alertMessages.fidgiContestEnabled[language]}</span>
              </div>
            )}
            {fidgiContest && fidgiContest?.toLowerCase() === "no" && (
              <div
                className="alert alert-danger mx-2 d-flex align-items-center fidgi-alert"
                role="alert"
              >
                <i className="bi bi-exclamation-triangle-fill fidgi-main-icon" aria-hidden="true"></i>
                {/* <i className="bi bi-x-octagon-fill fidgi-icon" aria-hidden="true"></i> */}
                <span className="fidgi-text">{translations.alertMessages.fidgiContestDisabled[language]}</span>
              </div>
            )}
          </div>

          <EventViewHeader
            showStatusReport
            eventId={eventId}
            dealershipDetails={dashboardData?.dealershipDetails}
            isDarkMode={isDarkMode}
            setDisplayComponent={setDisplayComponent}
          />
          <div>
            <AppointmentsSection
              isDarkMode={isDarkMode}
              dashboardData={dashboardData}
              getDataByDate={getDataByDate}
              eventDates={eventDates}
            />
          </div>
          <div className="row">
            <div className="col-6">
              <SingleAppointmentsSection
                isDarkMode={isDarkMode}
                appointments={dashboardData?.appointments}
                getDataByDate={getDataByDate}
                eventDates={eventDates}
              />
            </div>
            <div className="col-6">
              <FollowUp
                isDarkMode={isDarkMode}
                appointments={dashboardData?.followUpAppointments}
                getDataByDate={getDataByDate}
                eventDates={eventDates}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvenView;
